// Manager (ASM) — Reports hub. A single entry point from the field More
// menu into the report pages ASM already has permission for (their role
// already carries reports.attendance / reports.visits / reports.activity /
// reports.payments / reports.claims / reports.expenses / reports.targets /
// reports.view — see backend `roles` collection, role_code=ASM). These
// routes exist and are already reachable by URL; this page just gives ASM
// a way to find them from the field app, where there's no admin sidebar.
import { useNavigate } from "react-router-dom";
import {
  ChevronRight, ShoppingBag, MapPin, Clock, PhoneCall, RotateCcw,
  ClipboardList, Target, Boxes, BarChart3,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const REPORTS = [
  { to: "/sales-report", label: "Sales Report", icon: BarChart3 },
  { to: "/reports/order", label: "Order Report", icon: ShoppingBag },
  { to: "/reports/visit", label: "Visit Report", icon: MapPin },
  { to: "/reports/working", label: "Working Report", icon: Clock },
  { to: "/reports/new-call", label: "New Call Report", icon: PhoneCall },
  { to: "/reports/sales-return", label: "Sales Return Report", icon: RotateCcw },
  { to: "/reports/day-summary", label: "Day Summary", icon: ClipboardList },
  { to: "/reports/target-achievement", label: "Target Achievement", icon: Target },
  { to: "/reports/inventory", label: "Inventory Report", icon: Boxes },
];

function Row({ icon: Icon, label, onClick, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-neutral-50 active:bg-neutral-100 transition-colors"
    >
      <div className="h-9 w-9 rounded-xl bg-[#6D2C91]/10 text-[#6D2C91] flex items-center justify-center shrink-0">
        <Icon className="h-4.5 w-4.5" />
      </div>
      <div className="flex-1 min-w-0 text-sm font-semibold text-neutral-900">{label}</div>
      <ChevronRight className="h-4 w-4 text-neutral-300 shrink-0" />
    </button>
  );
}

export default function ReportsHub() {
  const navigate = useNavigate();
  return (
    <div className="p-4 pb-32 space-y-4" data-testid="reports-hub-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-400">Manager view</div>
        <h1 className="text-2xl font-extrabold text-neutral-900">Reports</h1>
      </div>
      <Card className="border-neutral-200 rounded-2xl overflow-hidden">
        <CardContent className="p-0 divide-y divide-neutral-100">
          {REPORTS.map((r) => (
            <Row key={r.to} icon={r.icon} label={r.label}
                 onClick={() => navigate(r.to)}
                 testid={`reports-hub-${r.to.replace(/\//g, "-")}`} />
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
